import type { GlobalLoaderProps } from "@expert/common-ui";
import { GlobalLoader } from "@expert/common-ui";
import type { JSX } from "react";
import { AsurionLogo } from "../assets/image/AsurionLogo";

type WorkspaceLoaderProps = Pick<GlobalLoaderProps, "msg">;

export const WorkspaceLoader = ({ msg }: WorkspaceLoaderProps): JSX.Element => (
    <GlobalLoader logo={<AsurionLogo />} msg={msg} />
);
